import JsonViewer from 'vue-json-viewer'
import { getShortTransactionLogId } from '@smarttransit/common'
import { formatProfitLabel, formatTransactionErrorLabel, isRefundablePenalty } from '@smarttransit/common-client'
import { refundAgentPenalty } from '../../services/agent-transaction-logs-service'

export default {
  name: 'agent-transaction-details-dialog',
  components: {
    JsonViewer
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Object,
      default: null
    },
    canRefundPenalty: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      refundInProgress: false
    }
  },
  computed: {
    dialogModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    typeLabel () {
      const iconData = this.transaction && this.transaction.logTypeIconData
      return (iconData && iconData.label) || 'Transaction'
    },
    statusLabel () {
      return (this.transaction && this.transaction.logStatusLabel) || ''
    },
    conversionRateLabel () {
      return (this.transaction && this.transaction.conversionRatePercentLabel) || ''
    },
    profitLabel () {
      const transaction = this.transaction
      if (!transaction) {
        return ''
      }
      return formatProfitLabel(
        transaction.logType,
        transaction.amount,
        transaction.conversionRatePercent,
        transaction.currencyPrefix || ''
      )
    },
    customerTransactionIdLabel () {
      const referenceId = this.transaction && this.transaction.transactionLogReferenceId
      return referenceId ? getShortTransactionLogId(referenceId) : ''
    },
    errorLabel () {
      return formatTransactionErrorLabel(this.transaction)
    },
    logMetadataValue () {
      const metadata = this.transaction && this.transaction.logMetadata
      if (metadata && typeof metadata === 'object') {
        return metadata
      }
      return {}
    },
    hasAccount () {
      const transaction = this.transaction
      return !!(transaction && (transaction.passengerPhoneNumberLabel || transaction.phoneNumberLabel || transaction.giftCounterpartyLabel || transaction.penaltyDetailLabel || transaction.penaltyHoldLabel))
    },
    hasBalance () {
      const transaction = this.transaction
      return !!(transaction && (transaction.profileBalanceBeforeLabel || transaction.profileBalanceAfterLabel))
    },
    statusHistory () {
      const history = this.transaction && this.transaction.statusHistory
      return history && history.length ? history : []
    },
    showRefundPenalty () {
      return this.canRefundPenalty && isRefundablePenalty(this.transaction)
    },
    refundConfirmText () {
      const transaction = this.transaction
      const detail = transaction && transaction.penaltyDetailLabel
      const topup = transaction && transaction.logMetadata && transaction.logMetadata.penaltyTopupAgentLogId
      const topupNote = topup ? ' The passenger fare top-up stays on the ticket. Refund that fare separately as an agent credit refund.' : ''
      return 'Refund this penalty?' + (detail ? ' ' + detail + '.' : '') + topupNote
    }
  },
  methods: {
    async refundPenalty () {
      if (!this.transaction || this.refundInProgress) {
        return
      }
      if (!confirm(this.refundConfirmText)) {
        return
      }
      try {
        this.refundInProgress = true
        await refundAgentPenalty({ id: this.transaction.id })
        this.$emit('refunded')
        this.dialogModel = false
        alert('Penalty refunded.')
      } catch (error) {
        alert(error && error.message ? error.message : error)
      } finally {
        this.refundInProgress = false
      }
    }
  }
}
